import {combineReducers} from 'redux'
import incomes from './incomes'

export const getAdditionalIncomes = (state) => {
  return state.incomes.slice(1)
}
export const getMainIncome = (state) => {
  return state.incomes[0]
}
export const getIncome = (state, props) => {
  const { id } = props;
  return id ? state.incomes.filter(income => income.key === id)[0] : state.incomes[0]
}

export default combineReducers({
  incomes
})
